import { render } from "./AnyButton.vue?vue&type=template&id=3edafa0c"
import script from "./AnyButton.vue?vue&type=script&lang=js"
export * from "./AnyButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__